'use client';

import { c as _c } from "react/compiler-runtime";
import type { Icon, Scheme } from '@personly/libs-types';
import { IconSelect } from '@personly/libs-widgets';
import { useOptions } from '@personly/libs-hooks';
import { useSchemes } from '@personly/libs-providers';
type LocalizedScheme = Scheme & {
  title: string;
};
interface Props {
  schemes: Array<LocalizedScheme>;
  schemeIcons: Icon[];
}
const SchemeSelect = t0 => {
  const $ = _c(9);
  const {
    schemes,
    schemeIcons
  } = t0;
  const {
    schemeHandle,
    setSchemeHandle
  } = useSchemes();
  let t1;
  if ($[0] !== schemeIcons) {
    t1 = handle => schemeIcons.find(icon => icon.handle === handle);
    $[0] = schemeIcons;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const schemeIcon = t1;
  const {
    options: schemeOptions,
    selectedOption: selectedSchemeOption
  } = useOptions(schemes, null, schemeHandle, _temp, _temp2);
  let t2;
  if ($[2] !== schemeOptions) {
    t2 = schemeOptions.map(_temp3);
    $[2] = schemeOptions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const options = t2;
  const selectedOption = selectedSchemeOption ? selectedSchemeOption.value : "";
  let t3;
  if ($[4] !== options || $[5] !== schemeIcon || $[6] !== selectedOption || $[7] !== setSchemeHandle) {
    t3 = <IconSelect icon={schemeIcon} options={options} selectedOption={selectedOption} setSelectedOption={setSchemeHandle} />;
    $[4] = options;
    $[5] = schemeIcon;
    $[6] = selectedOption;
    $[7] = setSchemeHandle;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default SchemeSelect;
function _temp(t0) {
  const {
    title
  } = t0;
  return title;
}
function _temp2(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp3(option) {
  return option.value;
}